module.exports = __webpack_public_path__ + "img/Chamaeleon.efa71878.png";